import { render, staticRenderFns } from "./nxMobileColor.vue?vue&type=template&id=6c49d748&scoped=true&"
import script from "./nxMobileColor.vue?vue&type=script&lang=js&"
export * from "./nxMobileColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c49d748",
  null
  
)

export default component.exports